/**
 * Chỉ cho phép truy cập các path tương ứng với role hiện tại; nếu không → redirect về trang chủ của role.
 */
import { useLocation, Navigate } from 'react-router-dom'
import { useAppSelector } from '../hooks/redux'
import { isPathAllowedForRole, getHomePathForRole } from '../config/roleRoutes'

interface RoleRouteGuardProps {
  children: React.ReactNode
}

export default function RoleRouteGuard({ children }: RoleRouteGuardProps) {
  const location = useLocation()
  const { user } = useAppSelector((state) => state.auth)
  const pathname = location.pathname
  const role = user?.role ?? 'user'

  if (!isPathAllowedForRole(pathname, role)) {
    return <Navigate to={getHomePathForRole(role)} replace />
  }

  return <>{children}</>
}
